import React from 'react';

const TrainingCenterSection = () => {
  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">IDA Schulungscenter</h2>
          <p className="text-xl text-gray-700">
            Mitarbeiter sensibilisieren, informieren und entwickeln – einfach sicher.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Card Container */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-gray-200">
          <div className="grid grid-cols-1 lg:grid-cols-5">

            {/* Left Side - Content (40%) */}
            <div className="lg:col-span-2 p-8 space-y-6">
              {/* Icon with Title */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-100 to-teal-200 rounded-xl flex items-center justify-center shadow-md flex-shrink-0">
                  <svg className="w-6 h-6 text-teal-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  Sensibilisierungsvideo für Mitarbeiter
                </h3>
              </div>

              {/* Quote Block - TEMPORARILY DISABLED */}
              {/*
              <blockquote className="border-l-4 border-teal-700 pl-4 italic text-gray-700 leading-relaxed">
                "Wir sind keine Psychologen – aber wir sind die ersten, die etwas merken können."
              </blockquote>
              */}

              {/* Description Text - TEMPORARILY DISABLED */}
              {/*
              <p className="text-gray-700 leading-relaxed">
                Dieses Video ist ein Beispiel aus dem IDA Schulungscenter. Es zeigt, wie Mitarbeiter für wichtige Compliance-Themen sensibilisiert werden können – praxisnah, verständlich und direkt im Arbeitsalltag abrufbar.
              </p>
              */}

              {/* Bold Header */}
              <h4 className="font-bold text-gray-900">Das IDA Schulungscenter bietet:</h4>

              {/* Feature List with Icons like "Warum IDA?" */}
              <div className="space-y-5">
                <div className="flex items-start gap-4 group">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1 group-hover:bg-teal-200 transition-colors">
                    <svg className="w-5 h-5 text-teal-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Praxisnahe Schulungsvideos</h5>
                    <p className="text-gray-700 leading-relaxed">Verständlich aufbereitet für den Arbeitsalltag</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1 group-hover:bg-teal-200 transition-colors">
                    <svg className="w-5 h-5 text-teal-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Interaktive Lernmodule</h5>
                    <p className="text-gray-700 leading-relaxed">Aktives Lernen statt passivem Zuhören</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1 group-hover:bg-teal-200 transition-colors">
                    <svg className="w-5 h-5 text-teal-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Automatische Schulungsnachweise</h5>
                    <p className="text-gray-700 leading-relaxed">Dokumentation ohne zusätzlichen Aufwand</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 group">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1 group-hover:bg-teal-200 transition-colors">
                    <svg className="w-5 h-5 text-teal-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-1">Zentrale Verwaltung & Reporting</h5>
                    <p className="text-gray-700 leading-relaxed">Überblick über alle Schulungsaktivitäten</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Video (randabfallend, 60%) */}
            <div className="lg:col-span-3 relative flex items-center justify-center bg-teal-50">
              <video
                controls
                className="w-full h-full"
                preload="metadata"
              >
                <source
                  src="/videos/training-video.mp4"
                  type="video/mp4"
                />
                Ihr Browser unterstützt das Video-Tag nicht.
              </video>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TrainingCenterSection;
